import React, { useEffect, useState } from 'react';
import logo from './../../Assets/Images/logo.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { routesArr } from '../../routes';
import PlusBoxIcon from '../../Assets/Icons/PlusBoxIcon';
import { getCookie, removeCookie } from '../../api/utils';

function Sidebar() {
  const location = useLocation();
  const [activeRoute, setActiveRoute] = useState('/');
  let navigate = useNavigate();
  let token = getCookie('token');

  useEffect(() => {
    let activeRoute = routesArr.filter(obj => obj.route === location.pathname)[0];
    if (activeRoute) {
      if (activeRoute.route.includes('/book')) {
        setActiveRoute('/');
      } else {
        setActiveRoute(activeRoute.route);
      }
    }
    if (!token) {
      navigate('/login');
    }
  }, [location]);
  return (
    <div className={token ? 'sideBar h-[100%]' : 'hidden'}>
      <div className="innerSidebar w-full">
        <Link to="/">
          <img src={logo} />
        </Link>
        <h2 className="text-2xl font-extrabold my-8">Admin Panel</h2>
        <div className="links w-full">
          <Link to="/new-post">
            <button className="text-base flex h-12 justify-center items-center bg-white w-full px-6 py-4 rounded-xl mb-2  transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105 font-semibold font-[Poppins-Bold]">
              <PlusBoxIcon svgProp={{ className: 'mr-[8px]' }} pathProp={{ stroke: '#000' }} />
              New Post
            </button>
          </Link>
          {routesArr.map((a, i) =>
            a.display ? (
              <div
                key={i}
                className={`contentLink text-base flex justify-start items-center font-[Poppins-Bold] w-full px-6 h-[48px] rounded-xl mb-2 ${
                  a.route === activeRoute ? 'active' : null
                }`}>
                <Link to={a.route}>{a.name}</Link>
              </div>
            ) : null
          )}
          <div
            onClick={() => removeCookie('token')}
            className={`text-base flex justify-start items-center font-[Poppins-Bold] w-full px-6 h-[48px] rounded-xl mb-2 text-red-500`}>
            <Link to={'/login'}>Logout</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;

//
